export function knowledgeStatus(value) {
    const source = value && typeof value === 'object' ? value : {};
    const protection = source.protection && typeof source.protection === 'object' ? source.protection : {};
    return {
        worldEnabled: Array.isArray(source.knowledgeModes) && source.knowledgeModes.includes('world'),
        webAvailable: typeof source.worldWebSearch === 'boolean' ? source.worldWebSearch : null,
        demo: source.uiDemo === true,
        ...(typeof protection.policyEnforced === 'boolean' && typeof protection.dataRedaction === 'boolean' && protection.actionApprovals === 'policy'
            ? { protection: { policyEnforced: protection.policyEnforced, dataRedaction: protection.dataRedaction, actionApprovals: 'policy' } } : {}),
    };
}
//# sourceMappingURL=desktopKnowledge.js.map